import ArrowLink from "@/components/ui/arrow-link";
import Icon from "@/components/ui/Icon";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { memo } from "react";

export type CasesCardProps = {
  id?: number;
  title: string;
  description: string;
  imageUrl: string | StaticImageData;
  link?: string;
  linkLabel?: string;
  responsive?: boolean;
} & React.ComponentProps<"div">;

const CasesCard = ({
  title,
  imageUrl,
  description,
  link = "#",
  linkLabel = "Learn more",
  responsive = false,
  className,
}: CasesCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col border bg-white lg:bg-[#f9f9f9] border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl md:border-transparent transition-[box-shadow,border-color,background-color] hover:border-blue hover:bg-white hover:shadow-[0px_8px_16px_0_rgba(0,0,0,0.08)]",

        className
      )}
    >
      <div
        className={cn(
          "flex w-full relative overflow-hidden rounded-3xl lg:rounded-2xl shrink-0 aspect-[1/0.61]",
          { "hidden md:flex": responsive }
        )}
      >
        <Image
          alt={title}
          src={imageUrl}
          fill
          className="w-full h-full"
          objectFit="cover"
        />
      </div>
      <div className={cn("flex flex-col p-5 min-w-0 flex-auto lg:p-4", { "p-6 md:p-5": responsive })}>
        <div className="grid grid-cols-1 gap-3 place-content-start flex-auto">
          <Typography
            variant="titleMd"
            asChild
            className="font-semibold lg:leading-[150%]"
          >
            <h4>{title}</h4>
          </Typography>
          {!!description && (
            <Typography
              variant="labelMd"
              asChild
              className="text-gray-600 line-clamp-3 md:line-clamp-none leading-[160%] lg:text-sm lg:leading-[150%]"
            >
              <p>{description}</p>
            </Typography>
          )}
        </div>
        <div  className={cn("mt-auto pt-[23] pb-[11] sm:pt-3 sm:pb-0 flex", {"pt-[22] pb-[6] sm:pt-3 sm:pb-0": responsive})}>
          <ArrowLink href={link}>{linkLabel}</ArrowLink>
        </div>
      </div>
    </div>
  );
};

export default memo(CasesCard);
